/* Studio Steen preloadImages.js - v1.0.0
  Usage: preloadImages(array, function, 'debug');
  debug is optional
*/

function preloadImages(images, oncomplete, debug) {
  'use strict';
  var total = images.length,
      current = 0,
      d = (debug) ? true : false;

  function loadImage(current) {
    var img = new Image();
    if (d) {log('preloadImages: \t loading '+current+' / '+total);}
    img.onload = function() {
      current++;
      if (current === total) {
        if (d) {log('preloadImages: \t loading completed');}
        if (oncomplete && typeof(oncomplete) === 'function') {
          oncomplete();
        } else {
          return;
        }
      } else {
        loadImage(current);
      }
    };
    img.src = images[current].src;
  }

  loadImage(current);
}
